import React, { useEffect, useContext, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { withRouter } from 'react-router-dom';
import { axiosInstance } from '../../axios';
import auth from '../../content/common/auth.js';
import {
  updateCurrentUser,
  getLandingPath,
} from '../../content/common/utils.js';
import CurrentUser from '../../services/CurrentUser.js';
import OktaService from '../../services/OktaService';
import { AlertBoxContext } from '../context/AlertBoxContext';
import api from '../../Api';

const LoginCallback = props => {
  const { setAlert } = useContext(AlertBoxContext);
  const [message, setMessage] = useState('Completing Okta sign-in…');

  useEffect(() => {
    let cancelled = false;

    const finishLogin = async () => {
      try {
        await OktaService.handleLoginRedirect();
        // Drop any pre-Okta SimpleJWT leftovers so they cannot be sent by mistake.
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        const token = await OktaService.getAccessToken();
        if (!token) {
          throw new Error('No Okta access token after redirect');
        }
        axiosInstance.defaults.headers['Authorization'] = `Bearer ${token}`;
        // Clear any stale A360 idle lockout before loading profile
        await api.startSession();
        await updateCurrentUser(props.setUser);
        if (cancelled) return;
        const landingPath = getLandingPath(CurrentUser.getUser());
        auth.login(() => {
          props.history.replace(landingPath);
        });
      } catch (error) {
        console.error(error);
        if (cancelled) return;
        setMessage('Okta sign-in failed.');
        setAlert({
          open: true,
          message:
            error?.response?.data?.detail ||
            'Okta sign-in failed. Ensure your user exists in Audience-360.',
        });
        OktaService.clearLocalTokens();
        props.history.replace('/login');
      }
    };

    finishLogin();
    return () => {
      cancelled = true;
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography variant="body1">{message}</Typography>
    </Box>
  );
};

export default withRouter(LoginCallback);
